import { MQContent } from '../cfm';
import { WhitelistAction } from '../global';

export const MQ_SUBMIT = 'MQ_SUBMIT';
export const MQ_IN_PROGRESS = 'MQ_IN_PROGRESS';
export const MQ_CATEGORY = 'MQ_CATEGORY';
export const MQ_RESET_CATEGORY = 'MQ_RESET_CATEGORY';
export const MQ_STARTED = 'MQ_STARTED';
export const MQ_COMPLETED = 'MQ_COMPLETED';
export const MQ_MESSAGE_SHOW = 'MQ_MESSAGE_SHOW';
export const MQ_VALIDATION_SHOW = 'MQ_VALIDATION_SHOW';
export const MQ_ELIGIBLE = 'MQ_ELIGIBLE';
export const ELIGIBILITY_CANNOT_BE_DETERMINED = 'ELIGIBILITY_CANNOT_BE_DETERMINED';
export const MQ_SET_DECLARATION = 'MQ_SET_DECLARATION';
export const RESET_PAX_MQ = 'RESET_PAX_MQ';
export const RESET_MQ = 'RESET_MQ';

export type MQActions = MQInProgressAction | MQCategoryAction | MQSubmitAction | MQResetPaxAction;

export interface PaxMQState {
  questions?: Record<string, string>;
  score?: number;
  page?: number;
  paxId?: number;
}

export interface MQInProgress extends WhitelistAction {
  paxId?: number;
  planClass?: string;
  mqMessageShow?: boolean;
  eligibilityCannotBeDeterminedShow?: boolean;
  mqValidationShow?: boolean;
  questionnaires?: MQContent;
}

export interface QuestionnaireInProgress extends WhitelistAction {
  paxId?: number;
  planClass?: string;
  mqMessageShow?: boolean;
  eligibilityCannotBeDeterminedShow?: boolean;
  mqValidationShow?: boolean;
  isNA?: boolean;
  questionnaires?: MQContent;
  page?: number;
  setPage?;
  continueCallback?;
  formType?;
  initialValues?;
  pageContent?;
  validation?;
}

export interface MQInProgressAction {
  type: string;
  payload: MQInProgress;
}

export interface MQCategory extends WhitelistAction {
  paxId: number;
  planClass: string;
  category: string;
}

export interface MQCategoryAction {
  type: string;
  payload: MQCategory;
}
export interface MQSubmitAction {
  type: string;
  payload?: MQSubmit;
}

export interface MQResetPaxAction {
  type: string;
  payload: {
    paxId: number[] | number;
  };
}
export interface MQSubmit {
  paxId: number;
  paxMq: PaxMQState;
}
export interface MQEligible {
  mqEligible: boolean;
}

export interface MQState {
  [paxId: number]: PaxMQState[];
  rateCategory?: {
    [paxId: number]: MQCategory;
  };
  declaration?: {
    [paxId: number]: boolean;
  };
  mqStarted?: boolean;
  mqCompleted?: boolean;
  mqPaxIdEligible?: { [paxId: number]: MQEligible };
  inProgressMQ: MQInProgress;
}
